export const CalculerSommeTotalsByPassage = (liste) => {
    return liste.reduce((somme, objet) => {
        return somme + (objet.total || 0); // Ajoute 'objet.total' à 'somme', en utilisant 0 si 'objet.total' est undefined
    }, 0); // Commence avec une somme de 0
}